import useBrandName from 'utility/hooks/useBrandName';

export interface BrandPolicyLinks {
	privacyPolicy: string;
	termsOfService: string;
	acceptableUsePolicy: string;
	policies: string;
}

const policyLinksMap: Record<string, BrandPolicyLinks> = {
	'Liquid Web': {
		privacyPolicy: 'https://www.liquidweb.com/policies/privacy-policy/',
		termsOfService: 'https://www.liquidweb.com/policies/terms-of-service/',
		acceptableUsePolicy:
			'https://www.liquidweb.com/policies/acceptable-use-policy/',
		policies: 'https://www.liquidweb.com/policies/',
	},
	Nexcess: {
		privacyPolicy: 'https://www.nexcess.com/policies/privacy-policy',
		termsOfService: 'https://www.nexcess.com/policies/terms-of-service',
		acceptableUsePolicy:
			'https://www.nexcess.com/policies/acceptable-use-policy',
		policies: 'https://www.nexcess.com/policies',
	},
};

const defaultLinks: BrandPolicyLinks = policyLinksMap['Liquid Web'];

const useBrandPolicyLinks = (): BrandPolicyLinks => {
	const brandName = useBrandName();
	return policyLinksMap[brandName] ?? defaultLinks;
};

export default useBrandPolicyLinks;
